import { useTranslation } from 'react-i18next';

import { BASE_CURRENCY, CURRENCIES } from '../../lib/currency';

type Props = {
  currency: string;
  onChange: (code: string) => void;
};

/**
 * Lets a visitor read list prices in their own currency. Presentation only —
 * plans are billed in USD.
 */
export default function CurrencySelect({ currency, onChange }: Props) {
  const { t } = useTranslation();

  return (
    <div className="inline-flex max-w-full items-center gap-3 rounded-full border border-gray-200 bg-white px-4 py-2 shadow-sm transition-colors hover:border-gray-300">
      <label htmlFor="pricing-currency" className="flex items-center gap-2 text-sm text-gray-500">
        <i className="ri-earth-line text-gray-400" aria-hidden="true"></i>
        <span className="whitespace-nowrap max-sm:sr-only">{t('pricing.currencyLabel')}</span>
      </label>
      <span className="h-4 w-px bg-gray-200 max-sm:hidden" aria-hidden="true"></span>
      <div className="relative">
        <select
          id="pricing-currency"
          value={currency}
          onChange={(e) => onChange(e.target.value)}
          className="cursor-pointer appearance-none bg-transparent pr-6 text-sm font-semibold text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1769ff]/30 rounded"
        >
          {CURRENCIES.map((c) => (
            <option key={c.code} value={c.code}>
              {c.code === BASE_CURRENCY
                ? `${c.code} — ${c.name} (${t('pricing.currencyBilledTag')})`
                : `${c.code} — ${c.name}`}
            </option>
          ))}
        </select>
        <i
          className="ri-arrow-down-s-line pointer-events-none absolute right-0 top-1/2 -translate-y-1/2 text-gray-400"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  );
}
